import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/ui/Header";
import HeroBackground from "./components/HeroBackground";
import TypingAnimation from "./components/TypingAnimation";
import HeroMetrics from "./components/HeroMetrics";
import HeroImage from "./components/HeroImage";
import HeroActions from "./components/HeroActions";
import ScrollIndicator from "./components/ScrollIndicator";
import SocialProof from "./components/SocialProof";

const HeroLaunchPad = () => {
  useEffect(() => {
    // Smooth scroll behavior for the page
    document.documentElement.style.scrollBehavior = "smooth";

    return () => {
      document.documentElement.style.scrollBehavior = "auto";
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Yash Pal - Full-Stack Developer | Yash Pal</title>
        <meta
          name="description"
          content="Experienced Full-Stack Developer specializing in React, Node.js, and modern web technologies. Available for freelance projects and full-time opportunities."
        />
        <meta
          name="keywords"
          content="full-stack developer, react developer, javascript, typescript, web development, portfolio"
        />
        <meta property="og:title" content="Yash Pal - Full-Stack Developer" />
        <meta
          property="og:description"
          content="Crafting exceptional web experiences with modern technologies"
        />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="/hero-launch-pad" />
      </Helmet>

      <div className="min-h-screen bg-background text-foreground">
        <Header />

        {/* Hero Section */}
        <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
          <HeroBackground />

          <div className="relative z-10 container mx-auto px-6 lg:px-8 pt-16">
            <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
              {/* Content Column */}
              <div className="text-center lg:text-left space-y-8">
                {/* Main Headline */}
                <div className="space-y-4">
                  <div className="inline-flex items-center px-4 py-2 bg-card/50 border border-border/50 rounded-full text-sm text-muted-foreground backdrop-blur-sm">
                    <div className="w-2 h-2 bg-success rounded-full mr-2 animate-pulse" />
                    Available for new opportunities
                  </div>

                  <h1 className="text-4xl lg:text-6xl xl:text-7xl font-bold leading-tight">
                    <span className="block text-foreground">Hi, I'm</span>
                    <span className="block bg-gradient-to-r from-conversion-accent to-trust-builder bg-clip-text text-transparent">
                      Yash Pal
                    </span>
                  </h1>

                  <div className="text-xl lg:text-2xl text-muted-foreground">
                    <span>I'm a </span>
                    <TypingAnimation />
                  </div>
                </div>

                {/* Description */}
                <p className="text-lg text-muted-foreground max-w-2xl leading-relaxed">
                  Passionate about crafting exceptional digital experiences
                  through clean code, innovative solutions, and collaborative
                  teamwork. I transform complex problems into elegant,
                  user-friendly applications.
                </p>

                {/* Call-to-Action Buttons */}
                <HeroActions />

                {/* Key Highlights */}
                <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 text-sm text-muted-foreground">
                  <div className="flex items-center space-x-2">
                    <div className="w-1 h-1 bg-conversion-accent rounded-full" />
                    <span>1+ Years Experience</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <div className="w-1 h-1 bg-trust-builder rounded-full" />
                    <span>4+ Projects Completed</span>
                  </div>
                  {/* <div className="flex items-center space-x-2">
                    <div className="w-1 h-1 bg-cta rounded-full" />
                    <span>100% Client Satisfaction</span>
                  </div> */}
                </div>
              </div>

              {/* Image Column */}
              <div className="flex justify-center lg:justify-end">
                <HeroImage />
              </div>
            </div>

            {/* Metrics Section */}
            <HeroMetrics />
          </div>

          {/* Scroll Indicator */}
          {/* <ScrollIndicator /> */}
        </section>

        {/* Quick Preview Section */}
        <section className="py-20 bg-card/20 border-t border-border/50 mt-12">
          <div className="container mx-auto px-6 lg:px-8">
            <div className="text-center space-y-8">
              <div className="space-y-4">
                <h2 className="text-3xl lg:text-4xl font-bold">
                  Ready to Build Something Amazing?
                </h2>
                <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
                  Let's collaborate on your next project and bring your vision
                  to life with cutting-edge technology and exceptional user
                  experience.
                </p>
              </div>

              {/* <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
                <div className="text-center space-y-3">
                  <div className="w-16 h-16 bg-gradient-to-br from-conversion-accent/20 to-conversion-accent/10 rounded-full flex items-center justify-center mx-auto">
                    <span className="text-2xl">🚀</span>
                  </div>
                  <h3 className="text-xl font-semibold">Fast Delivery</h3>
                  <p className="text-muted-foreground">
                    Quick turnaround without compromising quality
                  </p>
                </div>

                <div className="text-center space-y-3">
                  <div className="w-16 h-16 bg-gradient-to-br from-trust-builder/20 to-trust-builder/10 rounded-full flex items-center justify-center mx-auto">
                    <span className="text-2xl">💎</span>
                  </div>
                  <h3 className="text-xl font-semibold">Premium Quality</h3>
                  <p className="text-muted-foreground">
                    Clean, maintainable code that scales
                  </p>
                </div>

                <div className="text-center space-y-3">
                  <div className="w-16 h-16 bg-gradient-to-br from-cta/20 to-cta/10 rounded-full flex items-center justify-center mx-auto">
                    <span className="text-2xl">🤝</span>
                  </div>
                  <h3 className="text-xl font-semibold">Great Communication</h3>
                  <p className="text-muted-foreground">
                    Regular updates and transparent process
                  </p>
                </div>
              </div> */}

              {/* Social Proof */}
              <SocialProof />
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default HeroLaunchPad;
